import React from 'react';
import { useLocation } from 'react-router-dom';
import './ParentDetailsScreen.css';

const ParentDetailsScreen = () => {
  const location = useLocation();
  const email = location.state?.email || 'No email provided';

  return (
    <div className="parent-details-screen">
      <h1>Parent Details</h1>
      <p>Email: {email}</p>
    </div>
  );
};

export default ParentDetailsScreen;
